import {
  useRecoilValue,
} from 'recoil';

import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import Divider from '@material-ui/core/Divider';
import HomeIcon from '@material-ui/icons/Home';
import SearchIcon from '@material-ui/icons/Search';
import InfoIcon from '@material-ui/icons/Info';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import ListIcon from '@material-ui/icons/List';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import NotificationIcon from '@material-ui/icons/Notifications';

import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';

import { userState } from '../helpers/userState';

export const platformPad = () => {
  let myNavigator = { userAgent: 'static' };
  try {
    myNavigator = navigator;
  } catch (e) {
    console.log('Navigator fetched during static render');
  }
  const userAgent = myNavigator.userAgent || '';
  const iPhoneRegex = /iPhone\s*([1-9][0-9])/;
  const iPhoneMatch = userAgent.match(iPhoneRegex);
  if (userAgent.includes('Market2dayIOS') && iPhoneMatch) {
    const modelNumber = parseInt(iPhoneMatch[1], 10);
    return modelNumber >= 10 ? '3rem' : '1rem';
  }
  return '0px';
};

const NavDrawer = ({
  open,
  close,
}) => {
  const user = useRecoilValue(userState) || {};
  const {
    is_vendor: isVendor,
    is_shopper: isShopper,
    is_market_manager: isMarketManager,
  } = user;
  return (
    <Drawer anchor="left" open={open} onClose={close}>
      <List css={{
        marginTop: platformPad(), width: '15rem',
      }}
      >
        <ListItem
          component={Link}
          to="/"
          button
          onClick={() => {
            close();
          }}
        >
          <ListItemIcon>
            <HomeIcon css={{ fontSize: '24px' }} />
          </ListItemIcon>
          <ListItemText primary="Home" />
        </ListItem>
        <ListItem
          component={Link}
          to="/about"
          button
          onClick={() => {
            close();
          }}
        >
          <ListItemIcon>
            <InfoIcon css={{ fontSize: '24px' }} />
          </ListItemIcon>
          <ListItemText primary="About" />
        </ListItem>
        <ListItem
          component={Link}
          to="/gift_cards"
          button
          onClick={() => {
            close();
          }}
        >
          <ListItemIcon>
            <CardGiftcardIcon css={{ fontSize: '24px' }} />
          </ListItemIcon>
          <ListItemText primary="Gift Cards" />
        </ListItem>
        { user?.id
          && (
          <div>
            <ListItem
              component={Link}
              to="/market-search"
              button
              onClick={() => {
                close();
              }}
            >
              <ListItemIcon>
                <SearchIcon css={{ fontSize: '24px' }} />
              </ListItemIcon>
              <ListItemText primary="Search" />
            </ListItem>
            <ListItem
              component={Link}
              to="/orders"
              button
              onClick={() => {
                close();
              }}
            >
              <ListItemIcon>
                <ShoppingBasketIcon css={{ fontSize: '24px' }} />
              </ListItemIcon>
              <ListItemText primary="My Basket" />
            </ListItem>
            <ListItem
              component={Link}
              to="/recent_orders"
              button
              onClick={() => {
                close();
              }}
            >
              <ListItemIcon>
                <ListIcon css={{ fontSize: '24px' }} />
              </ListItemIcon>
              <ListItemText primary="Recent Orders" />
            </ListItem>
            { isVendor && (
              <ListItem
                component={Link}
                to="/ledger"
                button
                onClick={() => {
                  close();
                }}
              >
                <ListItemIcon>
                  <AccountBalanceIcon css={{ fontSize: '24px' }} />
                </ListItemIcon>
                <ListItemText primary="Ledger" />
              </ListItem>
            )}
            <Divider />
            { (isVendor || isMarketManager || isShopper)
              && (
              <ListItem
                component={Link}
                to="/accounts"
                button
                onClick={() => {
                  close();
                }}
              >
                <ListItemIcon>
                  <AccountCircleIcon css={{ fontSize: '24px' }} />
                </ListItemIcon>
                <ListItemText primary="Accounts" />
              </ListItem>
              )}
            <ListItem
              component={Link}
              to="/notification-preferences"
              button
              onClick={() => {
                close();
              }}
            >
              <ListItemIcon>
                <NotificationIcon css={{ fontSize: '24px' }} />
              </ListItemIcon>
              <ListItemText primary="Notifications" />
            </ListItem>
            <ListItem
              component={Link}
              to="/logout"
              button
              onClick={() => {
                close();
              }}
            >
              <ListItemIcon>
                <ExitToAppIcon css={{ fontSize: '24px' }} />
              </ListItemIcon>
              <ListItemText primary="Log Out" />
            </ListItem>
          </div>
          )}
      </List>
    </Drawer>
  );
};

export default withRouter(NavDrawer);
